function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["map", "visibleMarkers", "setVisibleMarkers", "selectedMarkerButton", "setSelectedMarkerButton", "searchInput", "sidebarMarkers", "activeMarkerGroup", "setActiveMarkerGroup"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef, useState } from 'react';
import L from "leaflet";
import * as turf from "@turf/turf";
var Sidebar = function Sidebar(_ref) {
  var map = _ref.map,
    visibleMarkers = _ref.visibleMarkers,
    setVisibleMarkers = _ref.setVisibleMarkers,
    selectedMarkerButton = _ref.selectedMarkerButton,
    setSelectedMarkerButton = _ref.setSelectedMarkerButton,
    searchInput = _ref.searchInput,
    sidebarMarkers = _ref.sidebarMarkers,
    activeMarkerGroup = _ref.activeMarkerGroup,
    setActiveMarkerGroup = _ref.setActiveMarkerGroup,
    props = _objectWithoutProperties(_ref, _excluded);
  var initialMarkerTypeButton = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sidebarMarkersLoaded = _useState2[0],
    setSidebarMarkersLoaded = _useState2[1];
  var updateVisibleMarkers = function updateVisibleMarkers(target, updatedMarkers) {
    setSelectedMarkerButton(target);
    if (selectedMarkerButton === target) {
      setVisibleMarkers(sidebarMarkers);
      setSelectedMarkerButton(false);
    } else {
      setVisibleMarkers(updatedMarkers);
    }
  };
  var sortedMarkers = function sortedMarkers(markers) {
    Object.keys(markers).forEach(function (category) {
      markers[category].sort(function (a, b) {
        return a.properties.name.localeCompare(b.properties.name);
      });
    });
    return markers;
  };
  useEffect(function () {
    if (Object.keys(sidebarMarkers).length > 0 && !sidebarMarkersLoaded && initialMarkerTypeButton) {
      // Ensure the following code is only run once.
      setSidebarMarkersLoaded(true);

      // Set the first marker group as active on initial load.
      var sidebarMarkerType = Object.keys(sidebarMarkers)[0];
      var marker = sidebarMarkers[sidebarMarkerType];
      setActiveMarkerGroup(sidebarMarkerType);
      setVisibleMarkers(_defineProperty({}, sidebarMarkerType, marker));
      setSelectedMarkerButton(initialMarkerTypeButton.current);
    }
  }, [sidebarMarkers]);
  useEffect(function () {
    if (searchInput !== '') {
      setActiveMarkerGroup('');
      if (selectedMarkerButton) {
        setSelectedMarkerButton(false);
      }
    } else {
      setSelectedMarkerButton(false);
    }
  }, [searchInput]);
  return /*#__PURE__*/React.createElement("div", props, Object.keys(sidebarMarkers).map(function (markerType, markerTypeIndex) {
    return /*#__PURE__*/React.createElement("ul", {
      key: markerType
    }, /*#__PURE__*/React.createElement("li", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("button", {
      ref: markerTypeIndex === 0 ? initialMarkerTypeButton : null,
      dangerouslySetInnerHTML: {
        __html: "".concat(markerType, "<span class=\"o-map__sidebar-button-count\">").concat(sidebarMarkers[markerType].length, "</span>")
      },
      className: ['o-map__sidebar-button', 'group', 'py-5', 'text-h4', 'text-black', activeMarkerGroup === markerType && 'o-map__sidebar-button--active', markerType === 'Toilets' && 'o-map__sidebar-button--disable-child'].join(' '),
      onClick: function onClick(_ref2) {
        var target = _ref2.target;
        // Set zoom to show roughly whole map when sidebar is clicked,
        // useful for zooming out after a maker group has been selected.
        map.setZoom(15);
        setActiveMarkerGroup(target === selectedMarkerButton && activeMarkerGroup === markerType ? '' : markerType);
        updateVisibleMarkers(target, _defineProperty({}, markerType, sidebarMarkers[markerType]));
      }
    }), /*#__PURE__*/React.createElement("ul", {
      className: "".concat(activeMarkerGroup !== '' && activeMarkerGroup !== markerType && 'hidden')
    }, sortedMarkers(sidebarMarkers)[markerType].map(function (marker, i) {
      var coordinates = marker.coordinates,
        properties = marker.properties;
      var name = properties.name;
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, /*#__PURE__*/React.createElement("button", {
        dangerouslySetInnerHTML: {
          __html: name
        },
        className: ['o-map__sidebar-button', 'group', 'py-2.5', 'text-h4', 'font-normal', 'text-black'].join(' '),
        onClick: function onClick(_ref3) {
          var target = _ref3.target;
          setActiveMarkerGroup(target === selectedMarkerButton ? '' : markerType);
          updateVisibleMarkers(target, _defineProperty({}, markerType, [marker]));
          if (coordinates) {
            // eslint-disable-next-line react/prop-types
            var newMarkers = coordinates.map(function (markerPosition) {
              var pos = turf.getGeom(turf.point(markerPosition));
              // Flip the position of the lat and lang so, they're
              // formatted correctly.
              var flippedPosition = turf.flip(pos).coordinates;

              // Create new marker instance that will be added to
              // group.
              return L.marker(flippedPosition);
            });
            var featureGroup = L.featureGroup(newMarkers);

            // Set the map to show only the group of markers
            // selected.
            // eslint-disable-next-line react/prop-types
            map.fitBounds(featureGroup.getBounds(), {
              maxZoom: 16.1
            });
          }
        }
      }));
    }))));
  }));
};
export default Sidebar;